export default __webpack_public_path__ + "static/2-720c4c25fb5db18865441d3e28925720.jpg";